import { render, staticRenderFns } from "./ManageSalaries.vue?vue&type=template&id=34cf175c&scoped=true"
import script from "./ManageSalaries.vue?vue&type=script&lang=ts"
export * from "./ManageSalaries.vue?vue&type=script&lang=ts"
import style0 from "./ManageSalaries.vue?vue&type=style&index=0&id=34cf175c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf175c",
  null
  
)

export default component.exports